import { set } from 'date-fns';
import { UserTenant } from '@root/globalTypes';
import { TimeRange } from '@components/scheduling/timeRangePicker/types';
import { getCustomSetting } from '@utils/customSettings';
import { Emptied } from '@utils/types';

export const SHIFT_TIME_FORMAT = /^([01]\d|2[0-3]):[0-5]\d$/;

export const DEFAULT_SHIFT = { start: '07:00', end: '15:30' };

export const shiftTimeToMinutes = (value: string) => {
  const [hours, minutes] = value.split(':').map(Number);
  return hours * 60 + minutes;
};

const toMinutes = (value: unknown, fallback: string) =>
  shiftTimeToMinutes(typeof value === 'string' && SHIFT_TIME_FORMAT.test(value) ? value : fallback);

export const getTenantShift = (tenant: Emptied<UserTenant> | undefined): TimeRange => {
  const start = toMinutes(getCustomSetting(tenant, 'default_shift_start'), DEFAULT_SHIFT.start);
  const end = toMinutes(getCustomSetting(tenant, 'default_shift_end'), DEFAULT_SHIFT.end);
  if (start < end) return { start, end };

  return {
    start: shiftTimeToMinutes(DEFAULT_SHIFT.start),
    end: shiftTimeToMinutes(DEFAULT_SHIFT.end),
  };
};

let tenantShift = getTenantShift(undefined);

export const setTenantShift = (tenant: Emptied<UserTenant> | undefined) => {
  tenantShift = getTenantShift(tenant);
};

export const getShift = () => tenantShift;

const atMinutes = (day: Date, minutes: number) =>
  set(day, {
    hours: Math.floor(minutes / 60),
    minutes: minutes % 60,
    seconds: 0,
    milliseconds: 0,
  }).toISOString();

export const getShiftDates = (day: Date) => ({
  startsAt: atMinutes(day, tenantShift.start),
  endsAt: atMinutes(day, tenantShift.end),
});
